export const NoPageFound = () => {

    return (
        <div>
            <p style={{textAlign: "center", fontSize: "20px"}}> 
            404 - No Such page found. Please check the URL
            </p>
        </div>
    )
}